import loadable from '@loadable/component';

export const OrgDashboardCreditsListContainerLoadable = loadable(
  () => import('./OrgDashboardCreditsListContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardCreditsListContainer,
  },
);
